import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get("/admin/users").then((r) => setUsers(r.data));
  }, []);

  return (
    <div className="text-white">
      <div className="uppercase tracking-[0.28em] text-xs text-brand-pink mb-3">Users</div>
      <h1 className="font-display text-4xl mb-8">All accounts</h1>

      <div className="rounded-3xl bg-white/5 border border-white/10 overflow-hidden">
        <div className="grid grid-cols-12 text-xs uppercase tracking-widest text-white/50 px-5 py-3 border-b border-white/5">
          <div className="col-span-4">Name</div>
          <div className="col-span-4">Email</div>
          <div className="col-span-2">Role</div>
          <div className="col-span-2">Joined</div>
        </div>
        {users.map((u) => (
          <div key={u.id} data-testid={`admin-user-${u.id}`} className="grid grid-cols-12 px-5 py-4 border-b border-white/5 items-center text-sm">
            <div className="col-span-4">{u.name}</div>
            <div className="col-span-4 text-white/70">{u.email}</div>
            <div className="col-span-2"><span className={`px-3 py-1 rounded-full text-xs ${u.role === "admin" ? "bg-brand-pink text-white" : "bg-white/10 text-white/70"}`}>{u.role}</span></div>
            <div className="col-span-2 text-white/60">{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</div>
          </div>
        ))}
        {users.length === 0 && <div className="p-10 text-center text-white/50">No users yet.</div>}
      </div>
    </div>
  );
}
